export default __webpack_public_path__ + "static/media/refNo-plan.b6840305.jpg";